export default "__VITE_ASSET__3f393176__"